import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Box,
  Chip,
  Typography,
  InputLabel,
} from '@mui/material';

const defaultGoals = ['Exercise', 'Nutrition'];

const Step3Goals = ({ formData, handleChange, nextStep, prevStep }) => {
  const [error, setError] = useState('');
  const [newGoal, setNewGoal] = useState('');

  useEffect(() => {
    if (!formData.goals || formData.goals.length === 0) {
      handleChange({ target: { name: 'goals', value: defaultGoals } });
    } else {
      const missingDefaults = defaultGoals.filter((g) => !formData.goals.includes(g));
      if (missingDefaults.length > 0) {
        handleChange({
          target: { name: 'goals', value: [...missingDefaults, ...formData.goals] },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleAddGoal = () => {
    const trimmed = newGoal.trim();
    if (trimmed && !formData.goals.includes(trimmed)) {
      handleChange({ target: { name: 'goals', value: [...formData.goals, trimmed] } });
    }
    setNewGoal('');
  };

  const handleGoalKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddGoal();
    }
  };

  const handleDeleteGoal = (goal) => () => {
    if (defaultGoals.includes(goal)) return;
    handleChange({
      target: { name: 'goals', value: formData.goals.filter((g) => g !== goal) },
    });
  };

  const handleNext = () => {
    if (
      !formData.currentCountry ||
      !formData.currentState ||
      !formData.currentCity ||
      !formData.homeCountry ||
      !formData.homeState ||
      !formData.homeCity
    ) {
      setError('All location fields are required.');
      return;
    }
    setError('');
    nextStep();
  };

  return (
    <Box component="form" sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ mt: 1 }}>
        Current Residence
      </Typography>
      <TextField
        margin="normal"
        required
        fullWidth
        id="currentCountry"
        label="Country"
        name="currentCountry"
        value={formData.currentCountry || ''}
        onChange={handleChange}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        id="currentState"
        label="State"
        name="currentState"
        value={formData.currentState || ''}
        onChange={handleChange}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        id="currentCity"
        label="City"
        name="currentCity"
        value={formData.currentCity || ''}
        onChange={handleChange}
      />

      <Typography variant="h6" sx={{ mt: 2 }}>
        Where You Grew Up
      </Typography>
      <TextField
        margin="normal"
        required
        fullWidth
        id="homeCountry"
        label="Country"
        name="homeCountry"
        value={formData.homeCountry || ''}
        onChange={handleChange}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        id="homeState"
        label="State"
        name="homeState"
        value={formData.homeState || ''}
        onChange={handleChange}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        id="homeCity"
        label="City"
        name="homeCity"
        value={formData.homeCity || ''}
        onChange={handleChange}
      />

      <InputLabel sx={{ mt: 2 }}>Goals</InputLabel>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
        {(formData.goals || defaultGoals).map((goal) => (
          <Chip
            key={goal}
            label={goal}
            onDelete={defaultGoals.includes(goal) ? undefined : handleDeleteGoal(goal)}
          />
        ))}
      </Box>
      <TextField
        margin="normal"
        fullWidth
        label="Add Goal"
        value={newGoal}
        onChange={(e) => setNewGoal(e.target.value)}
        onKeyDown={handleGoalKeyDown}
      />
      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3, mb: 2 }}>
        <Button variant="outlined" onClick={prevStep}>
          Previous
        </Button>
        <Button variant="contained" onClick={handleNext}>
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default Step3Goals;
